import React, { useEffect } from 'react';
import { ConfigContext } from '../../Config/ConfigContext';
import { useContext } from 'react';
import http from '../../utils/http';
import { parseJwt } from '../../utils/jwt';
import {Box} from '@mui/material';
import auth from '../../utils/auth';
import MicrosoftOAuthProvider from '.';
import MicrosoftLogin from './MicrosoftLogin';
import { PublicClientApplication } from '@azure/msal-browser';

export default function MicrosoftOAuthChoice(props) {
    //const [authSucceeded, setAuthSucceeded] = useState(false);
    const {config} = useContext(ConfigContext);

    const authenticate = async (msalResponse) => {
        const bearerTokenObject = parseJwt(auth.getBearerToken());
        let tenantId = bearerTokenObject.tenantId;
        let initURL = `${config.uri.base}/user/init`;
        if (tenantId) initURL += `&tenantId=${tenantId}`;
        const bearerToken = await http.get({
            oauthResponse: JSON.stringify(msalResponse),
            signInPlatform: 'microsoft',
            signInToken: msalResponse.idToken,
        }, initURL, { withCredentials: true });

        auth.setBearerToken(bearerToken);
        //setAuthSucceeded(true);
        props.setAuthSuccess(true);
    }

    //checks for a response from msal redirect and logs in if present
    useEffect( () => {
        const handleAuthRedirect = async() => {
            const msalConfig = {
                auth: {
                    clientId: config.microsoftOAuth.clientId,
                    authority: `https://login.microsoftonline.com/${config.microsoftOAuth.tenantId}`
                }
            };
            const msalInstance = await PublicClientApplication.createPublicClientApplication(msalConfig);
            const msalResponse = await msalInstance.handleRedirectPromise();

            if(msalResponse){
                await authenticate(msalResponse)
            }
        }

        handleAuthRedirect();
    },[])
    
    return (
        <MicrosoftOAuthProvider 
            clientId={config.microsoftOAuth.clientId}
        >
            <Box sx={{
            }}>
                <MicrosoftLogin
                    ux_mode="redirect"
                    onSuccess={async (msalResponse) => {
                        await authenticate(msalResponse)
                    }}
                />
            </Box>
        </MicrosoftOAuthProvider>
    );
}
